import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core'
import { Router } from '@angular/router'

@Injectable({
	providedIn: 'root',
})
export class SharedContent {
	phoneNumber = signal<string>('')
	pageName = signal<string>('')

	constructor(
		private router: Router,
		@Inject(PLATFORM_ID) private platformId: Object,
	) {}

	setPhoneNumber(value: string): void {
		this.phoneNumber.set(value)
	}

	setPageName(value: string): void {
		this.pageName.set(value)
	}

	navigateTo(path: string): void {
		if (path === this.router.url && isPlatformBrowser(this.platformId)) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		} else {
			this.router.navigate([path])
		}
	}
}
